import { render, staticRenderFns } from "./PageVisitsTable.vue?vue&type=template&id=9129738a"
import script from "./PageVisitsTable.vue?vue&type=script&lang=js"
export * from "./PageVisitsTable.vue?vue&type=script&lang=js"
import style0 from "./PageVisitsTable.vue?vue&type=style&index=0&id=9129738a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports